import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { PopoverModule } from 'ngx-bootstrap/popover';

import { TimePickerComponent } from './time-picker.component';
import { TimePickerService } from './services/time-picker.service';

@NgModule({
    imports: [CommonModule, FormsModule, PopoverModule],
    exports: [TimePickerComponent],
    declarations: [TimePickerComponent],
    providers: [TimePickerService]
})
export class TimePickerModule {}
